export default __webpack_public_path__ + "static/media/iconNoGrabacion.5d1c7107.svg";